import { type ThemeState } from '@atlaskit/tokens';

import { DEFAULT_THEME } from './constants';

export const updateThemeObjectWithDefaultValues = (
	themeObject: Partial<ThemeState>,
): Partial<ThemeState> => ({
	...DEFAULT_THEME,
	...themeObject,
});
